import { render, staticRenderFns } from "./Gastos.vue?vue&type=template&id=37cc9b6c&scoped=true&"
import script from "./Gastos.vue?vue&type=script&lang=js&"
export * from "./Gastos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc9b6c",
  null
  
)

export default component.exports